import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {SettlementListResult, SettlementQueryParams} from '@/types/finance';
import {financeService} from '@/services/financeService';

interface FinanceState {
  settlements: SettlementListResult | null;
  loading: boolean;
  error: string | null;
}

const initialState: FinanceState = {
  settlements: null,
  loading: false,
  error: null,
};

// 异步 action：获取结算列表
export const fetchSettlements = createAsyncThunk(
  'finance/fetchSettlements',
  async (params: any) => {
    const response = await financeService.getSettlements(params);
    return response;
  },
);

// 异步 action：冻结支付授权
export const freezeAuthToPay = createAsyncThunk(
  'finance/freezeAuthToPay',
  async (params: any) => {
    const response = await financeService.freezeAuthToPay(params);
    return response;
  },
);

export const getOverdueDetails = createAsyncThunk(
  'finance/getOverdueDetails',
  async (params: SettlementQueryParams) => {
    const response = await financeService.getOverdueDetails(params);
    return response;
  }
);

const financeSlice = createSlice({
  name: 'finance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 获取结算列表
      .addCase(fetchSettlements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSettlements.fulfilled, (state, action) => {
        state.loading = false;
        state.settlements = action.payload;
      })
      .addCase(fetchSettlements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || '获取结算列表失败';
      })

      // 冻结支付授权
      .addCase(freezeAuthToPay.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(freezeAuthToPay.fulfilled, (state, action) => {
        state.loading = false;
        // 可以在这里更新状态，例如：
        // state.settlements = action.payload;
      })
      .addCase(freezeAuthToPay.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || '冻结支付授权失败';
      });
  },
});

export default financeSlice.reducer;
